module.exports = __webpack_public_path__ + "static/media/tip_dog_temperature_en.53ff9177.png";